/*
  ATD - Colecciones apiladas (atd-colstack1)

  Adorno, no estructura: el apilado y el traslape son CSS puro y funcionan sin este
  archivo. Aquí solo se calculan dos variables por elemento apilado:

    --atd-cs-tapado  0→1  cuánto lo ha cubierto el siguiente (mueve el velo oscuro)
    --atd-cs-p       0→1  cuánto lleva entrando en pantalla (mueve el zoom)

  Ojo con "tapado": no puede medirse sobre el propio elemento. Una vez pegado, su
  posición en pantalla ya no cambia y la cuenta daría siempre 0. Lo que hay que medir
  es la distancia al SIGUIENTE, que es el que se mueve.
*/

(() => {
  const MOVIL = '(max-width: 749px)';

  class ColStack {
    constructor(raiz) {
      this.raiz = raiz;
      this.enCola = false;
      this.medir();

      this.alHacerScroll = () => {
        if (this.enCola) return;
        this.enCola = true;
        requestAnimationFrame(() => {
          this.enCola = false;
          this.pintar();
        });
      };

      this.alRedimensionar = () => {
        this.medir();
        this.pintar();
      };

      // Chrome congela requestAnimationFrame en pestañas de fondo: si la página se
      // carga o se desplaza mientras está oculta, los valores quedan viejos. Al volver
      // a primer plano hay que repintar una vez.
      this.alVolver = () => {
        if (!document.hidden) this.pintar();
      };

      window.addEventListener('scroll', this.alHacerScroll, { passive: true });
      window.addEventListener('resize', this.alRedimensionar, { passive: true });
      document.addEventListener('visibilitychange', this.alVolver);
      this.pintar();
    }

    /**
     * En escritorio lo que se apila son las filas; en celular las filas se disuelven
     * (display:contents) y se apila cada tarjeta. Hay que mirar los mismos elementos
     * que mira el CSS, o las cuentas se hacen sobre cajas que no se están moviendo.
     */
    medir() {
      const esMovil = window.matchMedia(MOVIL).matches;
      this.piezas = Array.from(
        this.raiz.querySelectorAll(esMovil ? '.atd-colstack__card' : '.atd-colstack__row')
      );
      const top = getComputedStyle(this.raiz).getPropertyValue('--atd-cs-top').trim();
      this.top = parseFloat(top) || 0;
    }

    pintar() {
      const alto = window.innerHeight;

      for (let i = 0; i < this.piezas.length; i++) {
        const pieza = this.piezas[i];
        const caja = pieza.getBoundingClientRect();
        const siguiente = this.piezas[i + 1];

        let tapado = 0;
        if (siguiente && caja.height > 0) {
          const cajaSiguiente = siguiente.getBoundingClientRect();
          tapado = 1 - (cajaSiguiente.top - caja.top) / caja.height;
          tapado = Math.min(1, Math.max(0, tapado));
        }
        pieza.style.setProperty('--atd-cs-tapado', tapado.toFixed(3));

        const entrando = Math.min(1, Math.max(0, 1 - (caja.top - this.top) / alto));
        pieza.style.setProperty('--atd-cs-p', entrando.toFixed(3));
      }
    }

    destruir() {
      window.removeEventListener('scroll', this.alHacerScroll);
      window.removeEventListener('resize', this.alRedimensionar);
      document.removeEventListener('visibilitychange', this.alVolver);
    }
  }

  const instancias = new WeakMap();

  const arrancar = (contexto = document) => {
    contexto.querySelectorAll('.atd-colstack').forEach((raiz) => {
      if (instancias.has(raiz)) return;
      instancias.set(raiz, new ColStack(raiz));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => arrancar());
  } else {
    arrancar();
  }

  // El editor de tema reemplaza el nodo al cambiar un ajuste: hay que reenganchar.
  document.addEventListener('shopify:section:load', (evento) => arrancar(evento.target));
  document.addEventListener('shopify:section:unload', (evento) => {
    evento.target.querySelectorAll('.atd-colstack').forEach((raiz) => {
      const inst = instancias.get(raiz);
      if (inst) {
        inst.destruir();
        instancias.delete(raiz);
      }
    });
  });
})();
